import type { user } from "@/types/api/user.api";

type Role = user['role'];

export const AppRoutes = {
    HOME: '/',
    LOGIN: '/login',
    STUDENT_HOME: '/student-home',
    STUDENT_DASHBOARD: '/student-dashboard',
    FACILITATOR_PANEL: '/facilitator-panel',
    COORDINATOR_DASHBOARD: '/coordinator-dashboard',
};

const ROLE_ROUTES_MAP: Record<Role, string> = {
    Estudiante: AppRoutes.STUDENT_HOME,
    Facilitador: AppRoutes.FACILITATOR_PANEL,
    'Coordinador de curso': AppRoutes.COORDINATOR_DASHBOARD,
};

export const getPageForRole = (role: Role | null): string => {
    if (!role) return AppRoutes.LOGIN;
    return ROLE_ROUTES_MAP[role] || AppRoutes.HOME;
};

export const hasRequiredRole = (userRole: Role | null, allowedRoles: Role[]): boolean => {
    if (!userRole) return false;
    return allowedRoles.includes(userRole);
};
